module.exports = __webpack_public_path__ + "img/texture_1.cff7c25f.png";